export default __webpack_public_path__ + "static/media/icon-sort-up.959eb111.svg";